module.exports = __webpack_public_path__ + "static/media/shego.5bfa324c.png";